import { Theme } from '@mui/material/styles';
import { SystemStyleObject } from '@mui/system';
import { pxToRem } from 'src/common/utils/fonts';
import {
  paddingBottom2,
  paddingBottom4,
  paddingHorizontal12,
  paddingTop3,
  paddingTop4,
  paddingTop6,
} from 'theme/utility/utility.styles';

export const closeBtnStyle = {
  position: 'absolute',
  top: pxToRem(12),
  right: pxToRem(16),
  padding: '0',
};

export const dialogTitle: SystemStyleObject<Theme> = {
  ...paddingTop4,
  ...paddingBottom2,
  ...paddingHorizontal12,
};

export const detailsGrid: SystemStyleObject<Theme> = {
  ...paddingHorizontal12,
  ...paddingTop6,
};

export const dialogActions: SystemStyleObject<Theme> = {
  ...paddingBottom4,
  ...paddingTop3,
};
